import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useNISData = (year) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshIndex, setRefreshIndex] = useState(0);

const fetchData = useCallback(async () => {
    if (!year) return;
    setLoading(true);

    try {
  const { data } = await axiosApi.get(`/nis/nested/${year}`);
  setData(data);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch NIS data by label year');
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [year]);

  useEffect(() => {
    fetchData();
  }, [fetchData, refreshIndex]);

  // Function to trigger a refetch
  const refetch = () => setRefreshIndex((prev) => prev + 1);

  return { data, loading, error, refetch };
};

export default useNISData;
